import { useEffect, useRef, useState } from "react";
import { TopBar } from "../../../shared/topBar/TopBar"
import { AgGridReact } from "ag-grid-react";
import { sbaAxios } from "../../../utils/sbaAxios";
import { getThirdPartyDataAPI } from "../../../../config/apiConfig";
import { BreadCrumbs } from "../../../shared/breadCrumbs/BreadCrumbs";
import { exportToExcelUsingRef } from "../../../utils/excelExporter";
import download from '../../../../Images/download.svg';
import { UrlPath } from "../../../../config/routeConfig";
import moment from "moment/moment";
import { Link } from "react-router-dom";

export const ThirdPartyData=()=>{
    const [thirdPartyRowData,setThirdPartyRowData]=useState([]);
    const ref=useRef(); 
    useEffect(()=>{
        document.title="Third Party Data";
        setThirdPartyRowDataFromAPI();
    },[]);
    const setThirdPartyRowDataFromAPI=async()=>{
        const data = await fetchThirdPartyRowData();
        setThirdPartyRowData(data); 
    }

    const fetchThirdPartyRowData=async()=>{
        try {
        return await sbaAxios({url:getThirdPartyDataAPI});    
        } catch (error) {
            return [];
        }
    }

    const defaultColDef = {
        wrapHeaderText: true,
        autoHeaderHeight: true, resizable: true, sortable: true, filter: true, floatingFilter: true, flex: 1, filter: 'agTextColumnFilter',minWidth:100
    };
    const getDateFormatted=(value)=>{
        return <>{
        moment(value).format('MM/DD/YYYY')        
        }</>
    }
    const HyperlinkRenderer = (props) => {
        const handleLinkClick = (event) => {
          event.stopPropagation();
        };
        const CustomEntityId = props.data.CustomEntityId;
        return (
          <Link to={`${UrlPath.ThirdPartyDataDetails}${CustomEntityId}`} onClick={handleLinkClick}>
            {props.value}
          </Link>
        );
      };
    const thirdPartyDataColDef = [
        {
            headerName: 'Entity Name',
            field: 'CustomEntityName',
            cellRenderer:HyperlinkRenderer
        },
        {
            headerName: "Start Date", 
            field: "StartDate", 
            cellRenderer: (data) =>getDateFormatted(data.value)
        },
        {
            headerName: 'End Date',
            field: 'EndDate',
            cellRenderer: (data) =>getDateFormatted(data.value)

        },
        // {
        //     headerName: "Valuation Date", 
        //     field: "ValuationDate", 
        //     cellRenderer: (data) =>getDateFormatted(data.value)

        // },
        // {
        //     headerName: 'Value',
        //     field: 'Value',
        // }
    ];
    const Level = [
        { BreadCrumb: "Portfolio >", Routes: `/${UrlPath.PortfolioList}` },
        { BreadCrumb: "Third Party Data", Routes: `${UrlPath.PThirdPartyData}` }
      ];
    return <>
    <TopBar label={"Third Party Data"} />
        <div  className="mainContentData">
        <BreadCrumbs Levels={Level} />
          <div className="container-fluid">
              <div className="d-flex justify-content-end gap-2">
                {/* <button type="submit" className="p-sm-btn mx-1" onClick={navigateToAssetAdd} disabled={!isEditable} ><i className="fa-solid fa-plus" /> Add</button> */}
                <button type="button" className="p-sm-btn mx-1" onClick={() => { exportToExcelUsingRef(ref, "Third Party Data List.xlsx") }}><img src={download} alt="Excel" />Export</button>
              </div>
              <div className="ag-theme-alpine" style={{ width: '100%', height: '700px' }}>
                <AgGridReact
                     ref={ref}
                    columnDefs={thirdPartyDataColDef}
                    rowData={thirdPartyRowData}
                    defaultColDef={defaultColDef}
                    pagination={true}
                    paginationPageSize={20}
                    rowSelection="Single"
                />
              </div>
         </div>
       
        </div>
    </>
}